import React,{useState, useEffect} from "react";
import { Row, Col, Container, Button} from "react-bootstrap";
import { useParams } from 'react-router-dom';
import authService from "../services/authServices";
import "../css/Community.css"

const Community = () => {
  const [like, setLike] = useState("true");
  const [Update, setUpdate] = useState({ rate: "", subject: "", overall: "", activities:"", school:"", body:""});
  const [showUpdates, setShowUpdates] = useState([]);
  const { id } = useParams();
  const [CommunityPost, setCommunityPost] = useState(false);


  const handleCreatePost = () => {
    setCommunityPost(true);
    console.log(handleCreatePost)
  }
  const createUpdate = () => {
    authService.createUpdate(Update).then((res) => {
        if (res.data.error) {
            alert(res.data.error);
        } else {
            alert("Update created successfully");
            window.location.reload();
        }
    }
    );
  };
  useEffect(() => {
    authService.getUpdates().then((res) => {
        if (res.data.error) {
            alert(res.data.error);
        }
        setShowUpdates(res.data);
    });
}, []);
const delUpdate = (_id) => () => {
  authService.deleteUpdate(_id).then((res) => {
      console.log(res)
      if (res.data.error) {
          alert(res.data.error);
      } else {
          alert("Update deleted successfully");
          window.location.reload();
      }
  })
}
  return (
  <>
      <div className="upperSect-div">
        <div className = "overallRank-div">
        <div className="contact-bottom">
        <button onClick={handleCreatePost}>
          click here
        </button>
        </div>
        {CommunityPost ? (
          <Container className="container-box" fluid>
            <Row className="container-row">
              <div>

              <h1>Overall Rating</h1>
              <input
                type="text"
                placeholder="Enter title here"
                name="rate" 
                onChange={(e) => setUpdate({ ...Update, rate: e.target.value })}
                />
              <h2>Subject</h2>
              <input
                type="text"
                placeholder="Enter title here"
                name="subject" 
                onChange={(e) => setUpdate({ ...Update, subject: e.target.value })}
                />
              </div>
            </Row>
            <Row className="container-row-2">
              <Col>
                <h3>City</h3>
                <input
                type="text"
                placeholder="Enter title here"
                name="overall" 
                onChange={(e) => setUpdate({ ...Update, overall: e.target.value })}
                />
                <h3>Activities Rating</h3>
                <input
                type="text"
                placeholder="Enter title here"
                name="activities" 
                onChange={(e) => setUpdate({ ...Update, activities: e.target.value })}
                />
                <h3>Education Rating</h3>
                <input
                type="text"
                placeholder="Enter title here"
                name="school" 
                onChange={(e) => setUpdate({ ...Update, school: e.target.value })}
                />
              </Col>
              <Col>
              <h3>Body</h3>
              <textarea
                type="text"
                className="form-control"
                placeholder="Enter title here"
                name="title" 
                style={{ width: "500px" }}
                onChange={(e) => setUpdate({ ...Update, body: e.target.value })}
                ></textarea>
                 <input
                  id="file-upload"
                  type="file"
                  name="body"
                  multiple
                  hidden
              />
                <label htmlFor="file-upload" style={{display:"block"}}>
                      + Your media
                </label>
              </Col>
           
            </Row>
            {/* <Row>
              <Col>
              <button>
                Like
              </button>
              <button>
                Unlike
              </button>
              </Col>
              <Col>
              <input
                  id="file-upload"
                  type="file"
                  name="media"
                  multiple
                  hidden
              />
                <label htmlFor="file-upload">
                      + Your media
                </label>
              </Col>
            </Row> */}
             <Row className="contact-bottom">
              <div>
                <button onClick={createUpdate}>
                  Create Update
                </button>
              </div>
            </Row>
          </Container>
        ) :(
          <>
          
          <div style={{}}>
          {showUpdates.map((Updates, index) => (
            <>
          <p>Based on ratings</p> 
            <ul>
              <li style={{marginRight:"20px"}}><strong>8.9   Overall</strong></li>
              <li style={{marginRight:"20px"}}>8.5   Activities</li>
              <li style={{marginRight:"20px"}}>7.1   Schooling</li>
            </ul>
            </>
            ))}
          </div>
          <Container className="contact-bottom">
               {showUpdates.map((Updates, index) => (
                    <Col className="display_box">
                        <Col>
                            <p ><strong>Overall Rating:</strong> {Updates.rate}</p>
                            <p >City: {Updates.subject}</p>
                            <p >Activities Rating: {Updates.activities}</p>
                            <p >Education Rating: {Updates.school}</p>
                            
                        </Col>
                        <Col>
                        <p >Body: {Updates.body}</p>
                        </Col>
                          <Col>
                        <button onClick={delUpdate(Updates._id)}>
                                            Delete
                        </button>
                        </Col>
                    </Col>
                    // </Row>
                 

                ))}
          </Container>
          </>
        )}



          {/* <p id="overallRankNum">4/5</p>
          <p>Based on ratings</p> */}
        </div>
        {/* <div className = "cityName-div">
          <p id="cityName">City Name</p>
        </div>
      </div>
      <div className="reviewSect-div">
        <div className="subjectReviews-div">
            <ul>
              <li id="mainRating">4.5   Overall</li>
              <li>3.5   Activities</li>
              <li>4.1   Schooling</li>
            </ul>
        </div>
        <div className="bodyRev-div">
          <textarea className="bodyText"></textarea>
        </div> */}
      </div>

  </>
  );
};

export default Community; 
